// extracted by mini-css-extract-plugin
module.exports = {"main":"PartnershipSearch_main__Ai8lU","header":"PartnershipSearch_header__Ej3_U","input":"PartnershipSearch_input__1ZW_4","buttonSearch":"PartnershipSearch_buttonSearch__B4u0g"};